import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";
import { useI18n } from "@/i18n";

/** Modalità offline: l'app resta consultabile in sola lettura con i dati dell'ultimo aggiornamento. */
export const OfflineBanner = () => {
  const { t } = useI18n();
  const [off, setOff] = useState(() => typeof navigator !== "undefined" && !navigator.onLine);

  useEffect(() => {
    const on = () => setOff(false);
    const down = () => setOff(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", down);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", down);
    };
  }, []);

  if (!off) return null;
  return (
    <div className="mb-4 flex items-center gap-2 rounded-md border-2 border-amber-400 bg-amber-50 px-3 py-2.5 text-xs font-semibold text-amber-900" data-testid="offline-banner">
      <WifiOff className="h-4 w-4 shrink-0" /> {t("x.off.banner")}
    </div>
  );
};
